import { loanRoleApi } from 'app/services/api';
import { normalize, schema } from 'normalizr';

import { catchAsyncActionError } from 'utils/action';
import { createNamedActions } from 'utils/namedActionTypesProxy';

export const LOAN_ROLES_ACTION_TYPE = createNamedActions('loanRoles', {
  GET_LOAN_ROLES: 'GET_LOAN_ROLES',
  CREATE_LOAN_ROLE: 'CREATE_LOAN_ROLE',
  EDIT_LOAN_ROLE: 'EDIT_LOAN_ROLE',
  DELETE_LOAN_ROLE: 'DELETE_LOAN_ROLE',
});

const loanRolesSchema = new schema.Entity('data', {}, { idAttribute: 'loanRoleId' });

export const getLoanRolesAction = catchAsyncActionError(
  ({ includeDeletedRoles, includePotentialUsers, applicationId } = {}) =>
    async dispatch => {
      const { data } = await loanRoleApi.getLoanRoles({
        includeDeletedRoles,
        includePotentialUsers,
        applicationId,
      });

      return dispatch({
        type: LOAN_ROLES_ACTION_TYPE.GET_LOAN_ROLES,
        payload: normalize(data, [loanRolesSchema]).entities.data,
      });
    },
);

export const createLoanRoleAction = catchAsyncActionError(params => async dispatch => {
  const { data } = await loanRoleApi.createLoanRole(params);

  return dispatch({
    type: LOAN_ROLES_ACTION_TYPE.CREATE_LOAN_ROLE,
    payload: data,
  });
});

export const editLoanRoleAction = catchAsyncActionError(params => async dispatch => {
  const { data } = await loanRoleApi.editLoanRole(params);

  return dispatch({
    type: LOAN_ROLES_ACTION_TYPE.EDIT_LOAN_ROLE,
    payload: data,
  });
});

export const deleteLoanRoleAction = params => async dispatch => {
  const { data } = await loanRoleApi.deleteLoanRole(params);

  return dispatch({
    type: LOAN_ROLES_ACTION_TYPE.DELETE_LOAN_ROLE,
    payload: data,
    meta: params,
  });
};
